import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { Shield, X } from 'lucide-react';
import { Button } from '../ui/button';

const COOKIE_KEY = 'ofa_cookie_consent';

export default function CookieBanner() {
  const { language } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
    // Enable GA4
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
      });
    }
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_KEY, 'declined');
    setVisible(false);
    // Keep GA4 disabled
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
      });
    }
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] bg-[#14274B] border-t border-white/10 shadow-2xl"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <Shield className="w-5 h-5 text-[#2D78F6] flex-shrink-0 mt-0.5 sm:mt-0" />
          <p
            className="text-white/80 text-sm flex-1"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            {language === 'fr'
              ? 'Nous utilisons des cookies analytiques pour améliorer votre expérience. En acceptant, vous consentez à l\'utilisation de Google Analytics.'
              : 'We use analytical cookies to improve your experience. By accepting, you consent to the use of Google Analytics.'}
            {' '}
            <Link
              to="/privacy"
              className="text-[#2D78F6] hover:underline"
            >
              {language === 'fr' ? 'Politique de confidentialité' : 'Privacy Policy'}
            </Link>
          </p>
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={handleDecline}
              data-testid="cookie-decline"
              className="text-white/50 hover:text-white text-sm font-medium transition-colors px-3 py-2"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {language === 'fr' ? 'Refuser' : 'Decline'}
            </button>
            <Button
              onClick={handleAccept}
              data-testid="cookie-accept"
              className="bg-[#2D78F6] text-white hover:bg-white hover:text-[#14274B] text-sm px-5"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {language === 'fr' ? 'Accepter' : 'Accept'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
